<app-modal
  #modal
  (isDismissing)="closeModal()"
  [modalConfig]="{
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    customFooter: true,
    showFooter: false,
    titleText: 'Preview',
    options: {
      size: 'lg',
    }
  }">
  <button
    class="btn btn-closemodal"
    title="Close"
    aria-label="close"
    headerContent
    (click)="closeModal()">
    <i class="bi bi-x-lg text-white"></i>
  </button>

  <div *ngIf="formId" class="form-content py-4 px-5">
    <app-proforms-form [formId]="formId" [viewState]="viewStates.PREVIEW" />
  </div>
</app-modal>
